import styled from 'styled-components'

const Marker = styled.span`
	color: ${props => props.theme.primary};
`

export default Marker
